export enum PagesContainerColor {
    Grey = "grey",
    White = "white",
}
